import LiveCountriesBadge from './LiveCountriesBadge';

export default LiveCountriesBadge;
